import React, { useEffect, useRef, useState } from "react";

import style from "./Region.module.css";

export function RegionBtn(props){
    let [isOpen, setIsOpen] = useState(false);
    let containerRef = useRef();
    let [selectedUsage, setSelectedUsage] = useState([]);

    function handleClickOutside(ev){
        if (containerRef.current && !containerRef.current.contains(ev.target)){
            setIsOpen(false)
        }
    }

    useEffect(() => {
        window.addEventListener("mousedown", handleClickOutside);

        return () => {
            window.removeEventListener("mousedown", handleClickOutside);
        }
    }, []);

    useEffect(() => {
        setSelectedUsage(props.selected);
    }, []);

    /*useEffect(() => {
        props.setFunction(selectedUsage);
    }, [selectedUsage])*/

    function selectUse(use){
        if (selectedUsage.includes(use)){
            let cacheUse = [...selectedUsage];
            setSelectedUsage((prev) => {
                return prev.filter(c => c != use);
            });
            props.setFunction(cacheUse.filter(c => c != use));
            return;
        }
        let cacheUse = [...selectedUsage];
        setSelectedUsage((prev) => {
            return [...prev, use]
        });
        props.setFunction([...cacheUse, use]);
    }

    let middleIndex = Math.floor(props.categories.length / 2);

    let firstHalf = props.categories.slice(0, middleIndex);
    let secondHalf = props.categories.slice(middleIndex);

    return <div className={`${style.container}`} ref={containerRef}>
        <div className={`${style.button}`} onClick={() => {setIsOpen(!isOpen)}}>
            <div className={`${style.button_text}`}>
                منطقه
            </div>
            <div className={`${style.button_icon}`}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style={{width: "20px", height: "20px"}}><path d="M241 369c-9.4 9.4-24.6 9.4-33.9 0L47 209c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 369z"/></svg>
            </div>
        </div>
        <div className={`${style.content}`} dir="rtl" hidden={!isOpen}>
            <div className={`${style.content_items_right}`}>
                {secondHalf.map((category) => {
                    return <div className={`${style.content_item}`} onClick={() => selectUse(category.id)}>
                            <div className={`${style.content_item_mark_holder}`}><div className={`${style.content_item_mark}`}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style={{width: "20px", height: "20px"}} hidden={!selectedUsage.includes(category.id)}><path d="M441 103c9.4 9.4 9.4 24.6 0 33.9L177 401c-9.4 9.4-24.6 9.4-33.9 0L7 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l119 119L407 103c9.4-9.4 24.6-9.4 33.9 0z"/></svg></div></div>
                            <div className={`${style.content_item_text}`}>{category.title}</div>
                        </div>
                })}
            </div>
            <div className={`${style.content_items_right}`}>
                {firstHalf.map((category) => {
                    return <div className={`${style.content_item}`} onClick={() => selectUse(category.id)}>
                            <div className={`${style.content_item_mark_holder}`}><div className={`${style.content_item_mark}`}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style={{width: "20px", height: "20px"}} hidden={!selectedUsage.includes(category.id)}><path d="M441 103c9.4 9.4 9.4 24.6 0 33.9L177 401c-9.4 9.4-24.6 9.4-33.9 0L7 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l119 119L407 103c9.4-9.4 24.6-9.4 33.9 0z"/></svg></div></div>
                            <div className={`${style.content_item_text}`}>{category.title}</div>
                        </div>
                })}
            </div>
        </div>
    </div>
}